export default "__VITE_ASSET__CxPBGja3__"